<template>
  <div class="row">
    <div class="col-sm-12 mb-0">
      <p>
        <span v-if="categoryDisabledAt">Enable Template Category</span>
        <span v-else>Disable Template Category</span>
      </p>
      <p v-if="!categoryDisabledAt" class="text-muted">
        Only template categories not linked to any active templates can be disabled.
      </p>
    </div>
  </div>
  <ActionToolbar v-if="categoryDisabledAt"
    :secondary-enabled="false"   
    :component-state="currentState" 
    :error-message="formError" 
    :success-message="successMessage"
    primary-button-text="Enable Template Category"
    @primary-click.prevent="onSubmitEnable()" />
  <ActionToolbar v-else :secondary-enabled="false"
    primary-style="danger"
    :component-state="currentState"  
    :error-message="formError" 
    :success-message="successMessage"
    primary-button-text="Disable Template Category"
    @primary-click.prevent="onSubmitDisable()" />
</template>

<script>
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useTemplateStore } from '@/src/stores/template';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";

export default {
  components: {
    ActionToolbar
  },
  mixins: [ savableStateMixin ],
  props: {
    categoryDisabledAt: { required: true },
    categoryId: { required: true, type: String }
  },
  emits: ['load-category'],
  setup() {
    const templateStore = useTemplateStore();
    return {
      templateStore
    }
  },
  data() {
    return {
      lastAction: null
    }
  },
  computed: {
    successMessage() {
      if (this.lastAction == 'disabled') return 'Successfully disabled Template Category';
      if (this.lastAction == 'enabled') return 'Successfully enabled Template Category';
      return this.categoryDisabledAt ? 'Successfully enabled Template Category' : 'Successfully disabled Template Category';
    }
  },
  methods: {
    async onSubmitDisable() {
      this.lastAction = 'disabled';
      await this.handleActivation('disabled');
    },
    async onSubmitEnable() {
      this.lastAction = 'enabled';
      await this.handleActivation('enabled');
    },
    async handleActivation(setState) {
      try {
        this.setSavableStateProcessing();
        const method = setState == 'disabled' ? this.templateStore.disableCategory : this.templateStore.enableCategory;
        const response = await method(this.categoryId);
        this.$emit('load-category', response);
        this.setSavableStateSuccess();
      } catch(error) {
        this.handleFormError(error);
      }
    }
  }
}
</script>
